import { useEffect, useRef } from "react";

// ============================================================
// FICHIER : USMapHero.tsx
// ============================================================

// index 0-15 = major US hubs
// index 16-30 = focus cities
const CITIES: [number, number][] = [
  [-84.39, 33.75],  // 0  ATL  Atlanta
  [-87.63, 41.88],  // 1  ORD  Chicago
  [-77.46, 38.95],  // 2  IAD  Washington DC
  [-80.84, 35.23],  // 3  CLT  Charlotte
  [-97.04, 32.90],  // 4  DFW  Dallas–Fort Worth
  [-104.99, 39.74], // 5  DEN  Denver
  [-73.78, 40.64],  // 6  JFK  New York
  [-118.41, 33.94], // 7  LAX  Los Angeles
  [-122.38, 37.62], // 8  SFO  San Francisco
  [-122.31, 47.45], // 9  SEA  Seattle
  [-112.01, 33.43], // 10 PHX  Phoenix
  [-80.29, 25.79],  // 11 MIA  Miami
  [-71.01, 42.36],  // 12 BOS  Boston
  [-93.22, 44.88],  // 13 MSP  Minneapolis–St Paul
  [-95.34, 29.98],  // 14 IAH  Houston
  [-115.15, 36.08], // 15 LAS  Las Vegas
  [-87.90, 43.00],  // 16 MKE  Milwaukee
  [-86.15, 39.77],  // 17 IND  Indianapolis
  [-90.20, 38.63],  // 18 STL  St. Louis
  [-86.78, 36.16],  // 19 BNA  Nashville
  [-90.05, 35.15],  // 20 MEM  Memphis
  [-90.07, 29.95],  // 21 MSY  New Orleans
  [-84.50, 39.10],  // 22 CVG  Cincinnati
  [-82.99, 39.96],  // 23 CMH  Columbus
  [-81.69, 41.50],  // 24 CLE  Cleveland
  [-79.99, 40.44],  // 25 PIT  Pittsburgh
  [-77.46, 37.54],  // 26 RIC  Richmond
  [-78.64, 35.78],  // 27 RDU  Raleigh
  [-83.92, 35.96],  // 28 TYS  Knoxville
  [-86.80, 33.52],  // 29 BHM  Birmingham
  [-82.55, 35.60],  // 30 AVL  Asheville
  [-75.16, 39.95],   // Philadelphia
[-76.61, 39.29],   // Baltimore
[-81.66, 30.33],   // Jacksonville
[-84.28, 30.44],   // Tallahassee
[-82.46, 27.95],   // Tampa
[-81.38, 28.54],   // Orlando
[-86.80, 36.17],   // Nashville area extra point if needed
[-84.51, 39.10],   // Cincinnati
[-95.99, 36.15],   // Tulsa
[-97.52, 35.47],   // Oklahoma City
[-94.58, 39.10],   // Kansas City
[-96.80, 32.78],   // Dallas
[-98.49, 29.42],   // San Antonio
[-97.74, 30.27],   // Austin
[-106.65, 35.08],  // Albuquerque
[-111.89, 40.76],  // Salt Lake City
[-116.20, 43.62],  // Boise
[-117.43, 47.66],  // Spokane
[-122.67, 45.52],  // Portland
[-121.49, 38.58],  // Sacramento
[-119.77, 36.74],  // Fresno
[-117.16, 32.72],  // San Diego
[-115.14, 36.17],  // Las Vegas
[-104.82, 38.83],  // Colorado Springs
[-96.00, 41.26],   // Omaha
[-93.27, 44.98],   // Minneapolis
[-87.91, 43.04],   // Milwaukee area
[-83.05, 42.33],   // Detroit
[-82.99, 39.96],   // Columbus area
[-78.88, 42.89],   // Buffalo
[-76.15, 43.05],   // Syracuse
[-73.75, 42.65],   // Albany
[-71.06, 42.36],   // Boston
[-70.26, 43.66],   // Portland, Maine
[-72.68, 41.76],   // Hartford
[-74.01, 40.71],   // New York City
[-79.94, 32.78],   // Charleston
[-80.19, 32.08],   // Savannah
[-81.03, 34.00],   // Columbia
];

const FLASH_INDICES = [
  16, // Milwaukee
  17, // Indianapolis
  18, // St. Louis
  22, // Cincinnati
  19, // Nashville
  20, // Memphis
  29, // Birmingham
  21, // New Orleans
  30, // Asheville
  28, // Knoxville
  27, // Raleigh
  26, // Richmond
  25, // Pittsburgh
  24, // Cleveland
  23, // Columbus
];
const ROUTES: [number, number][] = [
  // Focus cities <-> nearby hubs
  [16, 1], [16, 2],
  [17, 1], [17, 2], [17, 3],
  [18, 1], [18, 4],
  [19, 0], [19, 3],
  [20, 0], [20, 4],
  [21, 0], [21, 4],
  [22, 1], [22, 2],
  [23, 1], [23, 2],
  [24, 1], [24, 2],
  [25, 2], [25, 6],
  [26, 2], [26, 6],
  [27, 3], [27, 2],
  [28, 0], [28, 3],
  [29, 0],
  [30, 3], [30, 0],

  // Middle-America cluster
  [17, 18],
  [17, 22],
  [17, 23],
  [22, 23],
  [22, 24],
  [23, 24],
  [23, 25],
  [24, 25],
  [18, 19],
  [19, 20],
  [19, 29],
  [20, 21],
  [29, 28],
  [28, 30],
  [30, 27],
  [27, 26],
  [26, 25],
  [17, 19],
  [17, 28],

  // Indianapolis -> Pittsburgh
  [17, 25],

  // Coast-to-coast
  [1, 7],
  [1, 8],
  [1, 9],
  [1, 13],

  [4, 7],
  [4, 10],
  [4, 14],
  [4, 15],

  [0, 7],
  [0, 11],
  [0, 14],

  [6, 7],
  [6, 8],
  [6, 12],

  [5, 8],
  [5, 9],
  [5, 7],
  [5, 15],

  [2, 12],
  [2, 11],

  [7, 8],
  [7, 9],
  [7, 10],
  [7, 15],

  [8, 9],
  [9, 5],
  [10, 15],
  [3, 11],
  [13, 5],
  [14, 11],

  // Miami -> New York
  [11, 6],
];

function hashNoise(seed: number) {
  const x =
    Math.sin(seed * 12.9898) * 43758.5453;

  return x - Math.floor(x);
}

export default function USMapHero() {
  const svgRef =
    useRef<SVGSVGElement>(null);

  const canvasRef =
    useRef<HTMLCanvasElement>(null);

  const projRef =
    useRef<
      ((lon: number, lat: number) => [number, number]) | null
    >(null);

  // ============================================================
  // CARTE SVG
  // ============================================================

  useEffect(() => {
    const svg = svgRef.current;

    if (!svg) return;

    let observer: ResizeObserver | null = null;
    let cancelled = false;

    Promise.all([
  fetch("/shapes/usa-conus.geojson").then((r) => {
    if (!r.ok) {
      throw new Error(
        `usa-conus.geojson not found (status ${r.status})`
      );
    }
    return r.json();
  }),

  fetch("/shapes/alaska.geojson").then((r) => {
    if (!r.ok) {
      throw new Error(
        `alaska.geojson not found (status ${r.status})`
      );
    }
    return r.json();
  }),
]).then(([data, alaskaData]) => {
        if (cancelled) return;

        const coords: number[][][] = [];

        data.features.forEach(
          (feature: any) => {
            const geom = feature.geometry;

            if (!geom) return;

            const polys =
              geom.type === "MultiPolygon"
                ? geom.coordinates
                : [geom.coordinates];

            polys.forEach((poly: any) =>
              poly.forEach((ring: any) =>
                coords.push(ring)
              )
            );
          }
        );

        let minLon = Infinity;
        let maxLon = -Infinity;
        let minLat = Infinity;
        let maxLat = -Infinity;

        coords.forEach((ring) =>
          ring.forEach(
            ([lon, lat]: number[]) => {
              minLon = Math.min(
                minLon,
                lon
              );

              maxLon = Math.max(
                maxLon,
                lon
              );

              minLat = Math.min(
                minLat,
                lat
              );

              maxLat = Math.max(
                maxLat,
                lat
              );
            }
          )
        );

        const drawMap = () => {
          const W = svg.clientWidth;
          const H = svg.clientHeight;

          if (!W || !H) return;

          const pad = 20;

          const scaleX =
            (W - pad * 2) /
            (maxLon - minLon);

          const scaleY =
            (H - pad * 2) /
            (maxLat - minLat);

          const scale =
            Math.min(scaleX, scaleY);

          const mapWidth =
            (maxLon - minLon) * scale;

          const mapHeight =
            (maxLat - minLat) * scale;

          const offX =
            (W - mapWidth) / 2;

          const offY =
            (H - mapHeight) / 2;

          const project = (
            lon: number,
            lat: number
          ): [number, number] => [
            offX +
              (lon - minLon) * scale,

            H -
              (offY +
                (lat - minLat) *
                  scale),
          ];

          projRef.current = project;

          const ns =
            "http://www.w3.org/2000/svg";

          svg.innerHTML = "";

          // ====================================================
          // DEFINITIONS SVG
          // ====================================================

          const defs =
            document.createElementNS(
              ns,
              "defs"
            );

          const grad =
            document.createElementNS(
              ns,
              "linearGradient"
            );

          grad.setAttribute(
            "id",
            "ug"
          );

          grad.setAttribute(
            "x1",
            "0%"
          );

          grad.setAttribute(
            "y1",
            "0%"
          );

          grad.setAttribute(
            "x2",
            "100%"
          );

          grad.setAttribute(
            "y2",
            "100%"
          );

          [
            ["0%", "#00e6c3", "0.35"],
            ["55%", "#009983", "0.16"],
            ["100%", "#041f24", "0.03"],
          ].forEach(
            ([off, color, opacity]) => {
              const stop =
                document.createElementNS(
                  ns,
                  "stop"
                );

              stop.setAttribute(
                "offset",
                off
              );

              stop.setAttribute(
                "stop-color",
                color
              );

              stop.setAttribute(
                "stop-opacity",
                opacity
              );

              grad.appendChild(stop);
            }
          );

          const strokeGrad =
            document.createElementNS(
              ns,
              "linearGradient"
            );

          strokeGrad.setAttribute(
            "id",
            "usg"
          );

          strokeGrad.setAttribute(
            "x1",
            "0%"
          );

          strokeGrad.setAttribute(
            "y1",
            "0%"
          );

          strokeGrad.setAttribute(
            "x2",
            "100%"
          );

          strokeGrad.setAttribute(
            "y2",
            "100%"
          );

          [
            ["0%", "#00ffcc", "1"],
            ["45%", "#009983", "0.9"],
            ["75%", "#ffd243", "0.55"],
            ["100%", "#eb280f", "0.35"],
          ].forEach(
            ([off, color, opacity]) => {
              const stop =
                document.createElementNS(
                  ns,
                  "stop"
                );

              stop.setAttribute(
                "offset",
                off
              );

              stop.setAttribute(
                "stop-color",
                color
              );

              stop.setAttribute(
                "stop-opacity",
                opacity
              );

              strokeGrad.appendChild(
                stop
              );
            }
          );

          const glow =
            document.createElementNS(
              ns,
              "filter"
            );

          glow.setAttribute(
            "id",
            "uglow"
          );

          glow.setAttribute(
            "x",
            "-50%"
          );

          glow.setAttribute(
            "y",
            "-50%"
          );

          glow.setAttribute(
            "width",
            "200%"
          );

          glow.setAttribute(
            "height",
            "200%"
          );

          const blur =
            document.createElementNS(
              ns,
              "feGaussianBlur"
            );

          blur.setAttribute(
            "stdDeviation",
            "2.5"
          );

          blur.setAttribute(
            "result",
            "blur"
          );

          const merge =
            document.createElementNS(
              ns,
              "feMerge"
            );

          ["blur", "SourceGraphic"].forEach(
            (input) => {
              const node =
                document.createElementNS(
                  ns,
                  "feMergeNode"
                );

              node.setAttribute(
                "in",
                input
              );

              merge.appendChild(node);
            }
          );

          glow.appendChild(blur);
          glow.appendChild(merge);

          defs.appendChild(grad);
          defs.appendChild(
            strokeGrad
          );
          defs.appendChild(glow);

          svg.appendChild(defs);

          // ====================================================
          // DESSIN DES USA
          // ====================================================

          coords.forEach((ring) => {
            const d =
              ring
                .map(
                  (
                    [lon, lat]: number[],
                    i: number
                  ) => {
                    const [x, y] =
                      project(
                        lon,
                        lat
                      );

                    return `${
                      i === 0
                        ? "M"
                        : "L"
                    }${x.toFixed(
                      1
                    )},${y.toFixed(1)}`;
                  }
                )
                .join(" ") + " Z";

            const path =
              document.createElementNS(
                ns,
                "path"
              );

            path.setAttribute(
              "d",
              d
            );

            path.setAttribute(
              "fill",
              "url(#ug)"
            );

            path.setAttribute(
              "stroke",
              "url(#usg)"
            );

            path.setAttribute(
              "stroke-width",
              "1"
            );

            path.setAttribute(
              "filter",
              "url(#uglow)"
            );

            svg.appendChild(path);
          });
          // ====================================================
// ALASKA — encart + cadre + points jaunes
// ====================================================

const alaskaCoords: number[][][] = [];

alaskaData.features.forEach((feature: any) => {
  const geom = feature.geometry;
  if (!geom) return;

  const polys =
    geom.type === "MultiPolygon"
      ? geom.coordinates
      : [geom.coordinates];

  polys.forEach((poly: any) =>
    poly.forEach((ring: any) =>
      alaskaCoords.push(ring)
    )
  );
});

let akMinLon = Infinity;
let akMaxLon = -Infinity;
let akMinLat = Infinity;
let akMaxLat = -Infinity;

alaskaCoords.forEach((ring) =>
  ring.forEach(([lon, lat]: number[]) => {
    akMinLon = Math.min(akMinLon, lon);
    akMaxLon = Math.max(akMaxLon, lon);
    akMinLat = Math.min(akMinLat, lat);
    akMaxLat = Math.max(akMaxLat, lat);
  })
);

// ----------------------------------------------------
// Position / taille de l'encart Alaska
// ----------------------------------------------------

const akWidth = W * 0.18;
const akHeight = H * 0.20;

const akLeft = W * 0.035;
const akTop = H * 0.72;

const akPadding = 10;

const akScaleX =
  (akWidth - akPadding * 2) /
  (akMaxLon - akMinLon);

const akScaleY =
  (akHeight - akPadding * 2) /
  (akMaxLat - akMinLat);

const projectAlaska = (
  lon: number,
  lat: number
): [number, number] => [
  akLeft +
    akPadding +
    (lon - akMinLon) * akScaleX,

  akTop +
    akHeight -
    akPadding -
    (lat - akMinLat) * akScaleY,
];
// ----------------------------------------------------
// CADRE autour de l'Alaska
// ----------------------------------------------------

const framePadding = 12;

const alaskaFrame =
  document.createElementNS(
    ns,
    "rect"
  );

alaskaFrame.setAttribute(
  "x",
  String(akLeft - framePadding)
);

alaskaFrame.setAttribute(
  "y",
  String(akTop - framePadding)
);

alaskaFrame.setAttribute(
  "width",
  String(akWidth + framePadding * 2)
);

alaskaFrame.setAttribute(
  "height",
  String(akHeight + framePadding * 2)
);

alaskaFrame.setAttribute(
  "rx",
  "10"
);

alaskaFrame.setAttribute(
  "fill",
  "rgba(0,49,60,0.22)"
);

alaskaFrame.setAttribute(
  "stroke",
  "rgba(255,255,255,0.35)"
);

alaskaFrame.setAttribute(
  "stroke-width",
  "1"
);

svg.appendChild(alaskaFrame);

// ----------------------------------------------------
// DESSIN DE L'ALASKA
// ----------------------------------------------------

alaskaCoords.forEach((ring) => {
  const d =
    ring
      .map(
        ([lon, lat]: number[], i: number) => {
          const [x, y] =
            projectAlaska(lon, lat);

          return `${
            i === 0 ? "M" : "L"
          }${x.toFixed(1)},${y.toFixed(1)}`;
        }
      )
      .join(" ") + " Z";

  const path =
    document.createElementNS(
      ns,
      "path"
    );

  path.setAttribute("d", d);
  path.setAttribute(
    "fill",
    "url(#ug)"
  );
  path.setAttribute(
    "stroke",
    "url(#usg)"
  );
  path.setAttribute(
    "stroke-width",
    "1"
  );
  path.setAttribute(
    "filter",
    "url(#uglow)"
  );

  svg.appendChild(path);
});

// ----------------------------------------------------
// POINTS JAUNES EN ALASKA
// ----------------------------------------------------

// coordonnées [longitude, latitude]
const ALASKA_CITIES: [number, number][] = [
  [-149.9003, 61.2181], // Anchorage
  [-147.7164, 64.8378], // Fairbanks
  [-134.4197, 58.3019], // Juneau
  [-135.3300, 57.7900], // Sitka
  [-131.6461, 55.3422], // Ketchikan
  [-151.2583, 60.5544], // Kenai
];

ALASKA_CITIES.forEach(([lon, lat]) => {
  const [x, y] =
    projectAlaska(lon, lat);

  const dot =
    document.createElementNS(
      ns,
      "circle"
    );

  dot.setAttribute("cx", String(x));
  dot.setAttribute("cy", String(y));
  dot.setAttribute("r", "3");

  dot.setAttribute(
    "fill",
    "#ffd243"
  );

  dot.setAttribute(
    "stroke",
    "#ffd243"
  );

  dot.setAttribute(
    "stroke-width",
    "1"
  );

  dot.setAttribute(
    "filter",
    "url(#uglow)"
  );

  svg.appendChild(dot);
});
        };

        // Premier dessin
        drawMap();

        // Recalcule la projection dès que
        // la vraie taille de la carte change.
        observer =
          new ResizeObserver(() => {
            drawMap();
          });

        observer.observe(svg);
      })
      .catch((err) => {
        console.warn(
          "USMapHero: could not load usa-conus.geojson —",
          err.message
        );
      });

    return () => {
      cancelled = true;
      observer?.disconnect();
    };
  }, []);

  // ============================================================
  // ANIMATION CANVAS
  // ============================================================

  useEffect(() => {
    const canvas =
      canvasRef.current;

    if (!canvas) return;

    const ctx =
      canvas.getContext("2d");

    if (!ctx) return;

    let animId: number;
    let tick = 0;

    // ----------------------------------------------------------
    // Resize canvas
    // ----------------------------------------------------------

    const resize = () => {
      canvas.width =
        canvas.offsetWidth;

      canvas.height =
        canvas.offsetHeight;
    };

    resize();

    const canvasObserver =
      new ResizeObserver(() => {
        resize();
      });

    canvasObserver.observe(canvas);

    // ----------------------------------------------------------
    // Avion
    // ----------------------------------------------------------


    // ----------------------------------------------------------
    // Particules de fond
    // ----------------------------------------------------------

    const dust = Array.from(
      { length: 60 },
      (_, i) => ({
        xr: hashNoise(i * 3.1),

        yr: hashNoise(
          i * 7.7 + 1
        ),

        r:
          0.4 +
          hashNoise(
            i * 5.3 + 2
          ) *
            1.1,

        speed:
          0.2 +
          hashNoise(
            i * 2.2 + 3
          ) *
            0.5,

        phase:
          hashNoise(
            i * 9.9 + 4
          ) *
          Math.PI *
          2,
      })
    );

    // ----------------------------------------------------------
    // Animation des avions
    // ----------------------------------------------------------

    // Tous les avions parcourent
    // le même nombre de pixels par seconde.
    const PLANE_SPEED= 80;

    const HOLD = 1200;
    const FADE = 800;

    const SAMPLES = 60;

    // On garde environ un avion sur deux,
    // comme dans ton ancienne version.
    const FEATURED =
      ROUTES.map((_, i) => i).filter(
        (i) => i % 2 === 0
      );

    // On s'assure que Miami -> New York
    // possède bien un avion.
    const MIAMI_ROUTE_INDEX =
      ROUTES.length - 1;

    if (
      !FEATURED.includes(
        MIAMI_ROUTE_INDEX
      )
    ) {
      FEATURED.push(
        MIAMI_ROUTE_INDEX
      );
    }

    let startTime:
      | number
      | null = null;

    // ----------------------------------------------------------
    // Animation principale
    // ----------------------------------------------------------

    const animate = (ts: number) => {
      if (startTime === null) {
        startTime = ts;
      }

      const elapsed =
        ts - startTime;

      const W = canvas.width;
      const H = canvas.height;

      const proj =
        projRef.current;

      if (!proj) {
        animId =
          requestAnimationFrame(
            animate
          );

        return;
      }

      ctx.clearRect(
        0,
        0,
        W,
        H
      );

      tick += 1;

      // ========================================================
      // POUSSIERE / PARTICULES DE FOND
      // ========================================================

      dust.forEach((d) => {
        const x =
          d.xr * W;

        const y =
          (
            d.yr * H +
            tick *
              0.06 *
              d.speed
          ) % H;

        const tw =
          Math.sin(
            tick * 0.02 +
              d.phase
          ) *
            0.5 +
          0.5;

        ctx.beginPath();

        ctx.arc(
          x,
          y,
          d.r,
          0,
          Math.PI * 2
        );

        ctx.fillStyle =
          `rgba(0,230,195,${
            0.05 +
            tw * 0.1
          })`;

        ctx.fill();
      });

      

    

     // ========================================================
// VILLES
// ========================================================

const flashStart =
  Math.floor(elapsed / 150) % CITIES.length;

CITIES.forEach(([lon, lat], i) => {
  const [x, y] = proj(lon, lat);

const isFlashing =
  i === flashStart ||
  i === (flashStart + 7) % CITIES.length ||
  i === (flashStart + 15) % CITIES.length ||
  i === (flashStart + 24) % CITIES.length;

  // Tous les points restent jaunes
  ctx.beginPath();
  ctx.arc(
    x,
    y,
    3,
    0,
    Math.PI * 2
  );

  ctx.fillStyle = "#ffd243";
  ctx.shadowColor = "#ffd243";
  ctx.shadowBlur = 8;
  ctx.fill();

  ctx.shadowBlur = 0;

  // Une seule ville de la liste scintille en blanc
  if (isFlashing) {
    const pulse =
      Math.sin(tick * 0.15) * 0.5 + 0.5;

  
    // Point blanc par-dessus le jaune
    ctx.beginPath();
    ctx.arc(
      x,
      y,
      4,
      0,
      Math.PI * 2
    );

    ctx.fillStyle = "#ffffff";
    ctx.shadowColor = "#ffffff";
    ctx.shadowBlur = 20;
    ctx.fill();

    ctx.shadowBlur = 0;
  }
});
      animId = requestAnimationFrame(animate);
    };
        animId = requestAnimationFrame(animate);
        return () => {
      cancelAnimationFrame(animId);
      canvasObserver.disconnect();
    };
  }, [])
  ;
  

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: "500px",
        overflow: "hidden",
      }}
    >
      <svg
        ref={svgRef}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
        }}
      />

      <canvas
        ref={canvasRef}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}